import emailjs from "@emailjs/browser";

// Only define team1 cities - team2 will handle everything else..
const TEAM1_CITIES = new Set([
  "Pune", 
  "Mumbai", 
  "Mumbai Suburban", 
  "Palghar", 
  "Thane"
  
]);

// Directly use the environment variables
const EMAILJS_CONFIG = {
  serviceId: "service_hxqyijx",
  templateId: "template_ns4udpj",
  publicKey: "ttAkRyP_SvbMHcP2L"
};

const TEAM_EMAILS = {
  team1: ["namratabaldota@taxsarthi.com"],
  team2: ["sanketsalunkhe@taxsarthi.com"],
  default: ["apka@taxsarthi.com"]
};

export const sendQueryEmail = async (userData, queryText) => {
  try {
    // Validate configuration
    if (!EMAILJS_CONFIG.serviceId || !EMAILJS_CONFIG.templateId || !EMAILJS_CONFIG.publicKey) {
      throw new Error("EmailJS configuration is missing");
    }

    // Determine which team to use based on city
    const userCity = (userData.city || "").trim();
    let team = "team2"; // Default to team2
    
    // Check if city belongs to team1
    if (userCity && TEAM1_CITIES.has(userCity)) {
      team = "team1";
    }

    // Get recipients - fallback to default if team has no emails
    let recipients = TEAM_EMAILS[team] || TEAM_EMAILS.default;

    if (!recipients || recipients.length === 0) {
      throw new Error("No valid recipients configured");
    }

    // Convert recipients array to comma-separated string
    const recipientString = recipients.join(",");
    
    // Debug logging
    console.log("Email Debug Info:", {
      userCity,
      team,
      recipients,
      recipientString
    });

    const templateParams = {
      user_name: userData.name || "Not provided",
      user_pan: userData.pan || "Not provided",
      user_phone: userData.phone || "Not provided",
      user_query: queryText,
      email: recipientString, // Changed from to_email to email to match template
      user_city: userCity || "Unknown",
      assigned_team: team,
      reply_to: userData.email || "apka@taxsarthi.com"
    };

    // Additional debug logging
    console.log("Template Params:", templateParams);

    const result = await emailjs.send(
      EMAILJS_CONFIG.serviceId,
      EMAILJS_CONFIG.templateId,
      templateParams,
      EMAILJS_CONFIG.publicKey
    );

    console.log("EmailJS Success:", result);

    return { 
      success: result.status === 200,
      team,
      recipients
    };
  } catch (error) {
    console.error("Email sending failed:", error);
    
    // More detailed error logging
    if (error.status === 422) {
      console.error("422 Error Details:", {
        message: error.text,
        status: error.status,
        possibleCause: "Template configuration issue or missing to_email field"
      });
    }
    
    return { 
      success: false, 
      error: error.message || error.text || "Email sending failed",
      details: {
        city: userData.city,
        time: new Date().toISOString(),
        status: error.status
      }
    };
  }
};